
import { Target, Calendar, TrendingUp } from 'lucide-react';

interface Feature {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description: string;
  color: string;
}

interface FeaturesSectionProps {
  currentFeature: number;
}

const FeaturesSection = ({ currentFeature }: FeaturesSectionProps) => {
  const features: Feature[] = [
    {
      icon: Target,
      title: "Simple Focus",
      description: "No complications. Just create your PACT and show up every day.",
      color: "text-vibrant-orange"
    },
    {
      icon: Calendar,
      title: "Daily Tracking",
      description: "Mark your progress each day and build real momentum.",
      color: "text-deep-blue"
    },
    {
      icon: TrendingUp,
      title: "Build Consistency",
      description: "Transform small actions into lasting changes.",
      color: "text-vibrant-orange"
    }
  ];

  return (
    <section className="container max-w-6xl mx-auto px-4 py-20 bg-section-gradient rounded-3xl my-16">
      <h3 className="text-3xl font-bold text-center text-deep-blue mb-4">
        Why PACTs Work
      </h3>
      <p className="text-center text-deep-blue/70 mb-16 text-lg max-w-2xl mx-auto">
        Built on behavioral science and designed for real humans
      </p>
      
      <div className="grid md:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <div 
            key={index}
            className={`bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-sm border transition-all duration-500 hover:scale-105 ${
              index === currentFeature 
                ? 'border-vibrant-orange/50 shadow-lg bg-white' 
                : 'border-soft-blue/50 hover:border-vibrant-orange/30'
            }`}
          >
            <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto transition-all duration-300 ${
              index === currentFeature 
                ? 'bg-vibrant-orange text-white scale-110' 
                : 'bg-soft-blue text-deep-blue'
            }`}>
              <feature.icon className="w-8 h-8" />
            </div>
            <h4 className="text-xl font-semibold text-deep-blue mb-4 text-center">
              {feature.title}
            </h4>
            <p className="text-deep-blue/70 text-center leading-relaxed">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;
